export default __webpack_public_path__ + "static/media/mango.46f1344f.png";